import * as React from 'react';

import { IFeature } from 'shared/types/features';

import { OfferSummaryInfoGroup } from './OfferSummaryInfoGroup';
import { OfferSummaryInfoItem } from './OfferSummaryInfoItem';

interface IOfferSummaryInfoListProps {
  header: string;
  features: IFeature[];
  actionButton?: React.ReactNode;
  rightGroup?: boolean;
}

export const OfferSummaryInfoList: React.FC<IOfferSummaryInfoListProps> = ({
  header,
  features,
  actionButton,
  rightGroup,
}) => {
  return (
    <OfferSummaryInfoGroup header={header} actionButton={actionButton} rightGroup={rightGroup}>
      {features.map(({ label, value }, index) => (
        <OfferSummaryInfoItem key={label + index} name={label} value={value} />
      ))}
    </OfferSummaryInfoGroup>
  );
};
